var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadcrumb),function(item){return _c('el-breadcrumb-item',{key:item.id || item.path_name,attrs:{"to":item.path ? { path: item.path } : null}},[_vm._v(_vm._s(item.path_name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }